import { AuditCard } from "@/features/Audit/AuditCard";
import i18n from "@/i18n";
import { useParams } from "react-router-dom";
import { A6EventForm } from "./form";

const client = "a6";
const table_name = "a6_events";

export function A6EventsEdit() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <A6EventForm id={Number(id)} isNew={false} />
        <AuditCard id={Number(id)} client={client} audit_table_name={table_name} />
      </div>
    </div>
  );
}
